import { Typography } from "@mui/material";
import { FC } from "react";

interface IsMissionOnGoingColumnProps {
  isMissionOnGoing: boolean;
}

const IsMissionOnGoingColumn: FC<IsMissionOnGoingColumnProps> = ({ isMissionOnGoing }) => {
  return <Typography>{isMissionOnGoing ? "Oui" : "Non"}</Typography>;
};

export default IsMissionOnGoingColumn;
